/**
 *   Generated file. Do not edit
 */

import { ReadSelectedFileParams } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  selectFile: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/file-system/select-file',
    path: '/1032//1',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  unselectFile: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/file-system/unselect-file',
    path: '/1032//2',
  } as ServiceCallType<void, void>,

  writeSelectedFile: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/file-system/write-selected-file',
    path: '/1032//3',
  } as ServiceCallType<Uint8Array, void>,

  setSelectedFileBundleId: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/file-system/selected-file-bundle-id',
    path: '/1032//10',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  setSelectedFileUserId: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/file-system/selected-file-user-id',
    path: '/1032//11',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  readSelectedFile: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/file-system/read-selected-file',
    path: '/1032//4',
    bodyEncoder: allConverters.readSelectedFileParams,
  } as ServiceCallType<ReadSelectedFileParams, Uint8Array>,

  deleteSelectedFile: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/file-system/delete-selected-file',
    path: '/1032//6',
  } as ServiceCallType<void, void>,

  clearAllFiles: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/file-system/clear-all-files',
    path: '/1032//7',
  } as ServiceCallType<void, void>,

  getSelectedFileSize: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/file-system/selected-file-size',
    path: '/1032//5',
    responseBodyDecoder: allConverters.uint32,
  } as ServiceCallType<void, number>,

  listFiles: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/file-system/list-files',
    path: '/1032//9',
  } as ServiceCallType<void, void>,
};
